module.exports = __webpack_public_path__ + "img/shu5.66351a42.png";